import React from "react";
import { Facebook, Instagram, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
function NewsletterForm() {
  const {
    control,
    handleSubmit,
    isSubmitted,
    submitError,
    successMessage
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="18153" className="p-4 rounded-xl bg-secondary/10 border border-secondary/20 text-secondary">
        <p className="text-sm font-medium">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-2">
      <div className="flex flex-col gap-2">
        <FormField control={control} name="email" rules={{
        required: "El correo es obligatorio",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Correo inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormControl>
                <Input placeholder="tu@email.com" type="email" className="bg-card text-foreground border-transparent focus-visible:ring-secondary rounded-xl" {...field} />
              </FormControl>
              <FormMessage className="text-destructive" />
            </FormItem>} />
        <button type="submit" className="w-full bg-secondary text-secondary-foreground hover:bg-secondary/90 font-bold rounded-xl transition-all duration-300 shadow-md inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm h-10 px-4 py-2 cursor-pointer">
          Inscribirme <Send className="ml-2 h-4 w-4" />
        </button>
      </div>
      {submitError && <p className="text-sm text-destructive mt-2">{submitError}</p>}
    </Form>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/ecap.uy/",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://www.instagram.com/ecap_uruguay/",
    label: "Instagram"
  }];
  const quickLinks = [{
    label: "Inicio",
    to: "/HomePage"
  }, {
    label: "Oferta Académica",
    to: "/AcademicOfferPage"
  }, {
    label: "Contacto",
    to: "/ContactPage"
  }];
  return <section id="pie-de-página" className="bg-background text-foreground py-16 border-t-2 border-secondary/50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          <div className="space-y-6">
            <Link to="/HomePage" className="inline-block">
              <img src="https://optimum-pelican.10web.cloud/wp-content/uploads/2026/03/ECAP-1.jpg" alt="ECAP" className="h-7 w-auto object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs font-medium">
              ECAP es una academia líder en capacitaciones privadas en todo el interior de Uruguay, 
              formando profesionales en oficios, estética, salud, deportes y negocios con excelencia académica.
            </p>
          </div>

          <div className="space-y-6">
            <h3 className="text-xl font-sans font-extrabold tracking-tight text-secondary uppercase">
              Explorar
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.to} className="text-muted-foreground hover:text-secondary transition-colors duration-200 text-sm font-medium">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="space-y-6">
            <h3 className="text-xl font-sans font-extrabold tracking-tight text-secondary uppercase">
              Contacto Central
            </h3>
            <p className="text-muted-foreground text-sm mb-4 leading-relaxed font-medium">
              Tel: +59896344395<br />
              Email: info@ecap.edu.uy<br />
              Manuel Alvarez 93, Tacuarembó
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} className="bg-secondary/10 p-2.5 rounded-full hover:bg-secondary/20 group transition-all duration-300 shadow-sm" aria-label={social.label} data-index={i}>
                    <Icon className="h-5 w-5 text-foreground group-hover:text-secondary transition-colors duration-300" />
                  </Link>;
            })}
            </div>
          </div>

          <div className="space-y-6">
            <h3 className="text-xl font-sans font-extrabold tracking-tight text-secondary uppercase">
              Inscripciones
            </h3>
            <p className="text-muted-foreground text-sm font-medium">
              Suscríbete para recibir información sobre nuevos cursos, fechas de inicio y becas disponibles.
            </p>
            <FormProvider formId="newsletter-footer" sectionName="footer" defaultValues={{
            email: ""
          }} successMessage="¡Gracias por tu interés! Nos contactaremos pronto." errorMessage="Error al procesar la solicitud. Inténtalo de nuevo." className="w-full">
              <NewsletterForm />
            </FormProvider>
          </div>
        </div>

        <Separator className="my-12 bg-secondary/20" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-medium">
          <p>
            &copy; {currentYear} ECAP Escuela de Capacitaciones Privadas. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-2">
            <Link to="#" className="hover:text-secondary transition-colors">
              Aviso Legal
            </Link>
            <span className="text-secondary opacity-50">•</span>
            <Link to="#" className="hover:text-secondary transition-colors">
              Política de Privacidad
            </Link>
            <span className="text-secondary opacity-50">•</span>
            <Link to="#" className="hover:text-secondary transition-colors">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </section>;
}